import { client } from ".";

async function fetchPage(page: number) {
	const { data } = await client.get<ResultList<Lang>>(`/languages`, {
		params: { page },
	});
	return data;
}

async function store(item: StoreLang) {
	const { data } = await client.post<Result<Lang>>("/languages", item);
	return data;
}

async function update(id: number, item: StoreLang) {
	const { data } = await client.put<Result<Lang>>(`/languages/${id}`, item);
	return data;
}

async function destroy(id: number) {
	const { data } = await client.delete(`/languages/${id}`);
	return data;
}

const langAPI = {
	fetchPage,
	store,
	update,
	destroy,
};

export default langAPI;
